import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MessagesExtensionsFR } from '../app.config.types';

@Injectable({
  providedIn: 'root',
})
export class ConfigsService {
  constructor(private http: HttpClient) {}

  getMessagesExtensionsFR(): Observable<MessagesExtensionsFR> {
    return this.http.get<MessagesExtensionsFR>(
      `/botterfly/messages/extensions-front-reader/flatted`
    );
  }
}
